import styled from 'styled-components'
import Slider from '@material-ui/core/Slider'

const StyledSlider = styled(Slider)`

`

export default StyledSlider
